export enum LogLevel {
  Off = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  All = 666,
}
